import TYPES from '../types.js'

export const licenseState = {
  apiEnabled: '',
  applicationTokens: '',
  updateTimestamp: '',
  applicationTokensUsed: '',
}

export const licenseGetters = {
  apiEnabled: state => state.licenseState.apiEnabled,
  applicationTokens: state => state.licenseState.applicationTokens,
  updateTimestamp: state => state.licenseState.updateTimestamp,
  applicationTokensUsed: state => state.licenseState.applicationTokensUsed,
  applicationHide: state => {
    if (state.licenseState.apiEnabled == true && state.licenseState.applicationTokens > 0) {
      return true
    }
    return false
  },
  integratedShow: state => {
    return state.licenseState.integrationEnabled
  },
  canUseTokens: state =>
    state.licenseState.applicationTokens - state.licenseState.applicationTokensUsed,
}

export const licenseDataMutations = {
  [TYPES.GET_LICENSE_INFO](state, data) {
    state.licenseState = data
  },
}



// WEBPACK FOOTER //
// ./store/modules/m-get-licensedata.js